import { Component, OnInit, OnDestroy } from "@angular/core";
import { PlatformLocation, Location } from "@angular/common";
import { MapsAPILoader, MouseEvent } from "@agm/core";
import { ControlPosition } from "@agm/core/services/google-maps-types";
import { WebappService } from "../../../service/webapp.service";
import { environment } from ".././../../../environments/environment";
import { isDefined } from "@angular/compiler/src/util";
import { Router, ActivatedRoute} from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { timer } from "rxjs";
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: "app-confirm-booking",
  templateUrl: "./confirm-booking.component.html",
  styleUrls: ["./confirm-booking.component.scss"]
})
export class ConfirmBookingComponent implements OnInit, OnDestroy {
  public pickup_lat: number;
  public pickup_lng: number;
  public drop_lat: number;
  public drop_lng: number;
  public origin: any;
  public destination: any;
  private profilelog: any;
  private profileid: any;
  public rideDetails: any;
  public rideId: any;
  public notified: any;
  public bookingConfirmed: String = "0";
  public url: any;
  public timeLeft = 5;
  public interval;
  public zoom: any;
  public center_pos: any;
  public approx_price: any;
  currencySymbol: any = "$";
  constructor(
    private mapsAPILoader: MapsAPILoader,
    private apiservice: WebappService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    public toastr: ToastrService,
    private translate: TranslateService,
    public HTTP_REFERER: PlatformLocation,
    private location: Location
  ) {
    this.zoom = 5;
  } 

  ngOnInit() {

    this.activeRoute.queryParams.subscribe(params =>{ this.approx_price=params['categoryPrice']; });

    if (localStorage.getItem("CS")) {
      this.currencySymbol = localStorage.getItem("CS");
    }
    this.pickup_lat = Number(localStorage.getItem("pickup_lat"));
    this.pickup_lng = Number(localStorage.getItem("pickup_lon"));
    this.drop_lat = Number(localStorage.getItem("drop_lat"));
    this.drop_lng = Number(localStorage.getItem("drop_lon"));
    this.origin = { lat: this.pickup_lat, lng: this.pickup_lng };
    this.destination = { lat: this.drop_lat, lng: this.drop_lng };
    this.center_pos = {};
    this.rideData();
    this.url = environment.apiUrl;
  }

  onMapReady(map) {
    map.setOptions({
      zoomControl: "true",
      zoomControlOptions: {
        position: ControlPosition.TOP_RIGHT
      }
    });
  }

  rideData() {
    this.profilelog = JSON.parse(localStorage.getItem("user"));
    if (isDefined(this.profilelog)) {
      this.profileid = this.profilelog.id;
      this.apiservice.lastrequestedride(this.profileid).subscribe(data => {
        if (data["status"] === true) {
          this.rideDetails = data["result"];
          this.rideId = data["result"][0].ride_id;
          this.notified = data["result"][0].notified;
        }
      });
    }
  }

  confirmBooking() {
    this.bookingConfirmed = "1";
    this.alertnearbyDrivers();
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.alertnearbyDrivers();
      } else {
        let deniedRequest = {
          user_id: this.profileid,
          onride_id: this.rideId
        };
        this.apiservice.nodriverfound(deniedRequest).subscribe(data => {});
        this.toastr.error(this.translate.instant("Kindly try again later ..."));
        this.router.navigate(["/search"]);
      }
    }, 15000);
  }

  alertnearbyDrivers() {
    this.profilelog = JSON.parse(localStorage.getItem("user"));
    if (isDefined(this.profilelog)) {
      this.profileid = this.profilelog.id;
      let rideRequest = {
        user_id: this.profileid,
        onride_id: this.rideId,
        is_notify: "1"
      };
      this.apiservice.confirmride(rideRequest).subscribe(data => {
        if (data["status"] === "true") {
          this.toastr.success(this.translate.instant("Your Ride has been accepted"));
          this.router.navigate(["/active-rides", btoa(this.rideId)]);
        }
      });
    } else {
      this.router.navigate(["/login"]);
    }
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  goBack() {
    /* if (confirm("Are you sure want to go back?")) {
      let deniedRequest = {
        user_id: this.profileid,
        onride_id: this.rideId
      };
      this.apiservice.nodriverfound(deniedRequest).subscribe(data => {});
      this.router.navigate(["/search"]);
    } */
    this.router.navigate(["/search"]);
  }
}
